export default __webpack_public_path__ + "static/media/Amazon-Simple-Notification.bbe19205.svg";